import Papa from 'papaparse'
import GeoJSON from 'geojson'

export async function getcsvdata (url) {
  const parsePromise = url => {
    return new Promise((resolve, reject) => {
      try {
        Papa.parse(url, {
          download: true,
          header: true,
          complete: results => {
            resolve(results.data)
          }
        })
      } catch (error) {
        reject(error)
      }
    })
  }

  const parseResult = await parsePromise(url)
  return parseResult.map((item, id) => ({ ...item, id }))
}

export function aggregateByLocation (items) {
  // expected { location:string, Latitude:string, Longitude:string, items:object }[]
  return items.reduce((acc, current) => {
    let locationAggregate = acc.find(item => item.location === current['Currently based in'])
    if (!locationAggregate) {
      const { Latitude, Longitude } = current
      locationAggregate = { location: current['Currently based in'], Latitude, Longitude, items: [] }
      acc.push(locationAggregate)
    }
    locationAggregate.items.push(current)
    return acc
  }, [])
}

export function toGeoJSON (dataArray, config) {
  return GeoJSON.parse(dataArray, config)
}
